import { css } from '@linaria/core';
import { theming } from 'styles/utils';
export const metadataBlock = "odules__InputViewer__components__InputInfo__styles_ts-metadataBlock-mh5sp5p";

require("./styles.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./styles.ts");